/**
 * @generated SignedSource<<47bb10153f65166b4b698457b22c4ad0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoreNavItem_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToAnalytics: boolean;
      readonly hasAccessToFeedback: boolean;
      readonly hasAccessToObjectives: boolean;
    };
  };
  readonly hasAdminAccess: boolean;
  readonly " $fragmentType": "MoreNavItem_viewer";
};
export type MoreNavItem_viewer$key = {
  readonly " $data"?: MoreNavItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoreNavItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoreNavItem_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAdminAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToFeedback",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "feedback"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"feedback\")"
            },
            {
              "alias": "hasAccessToObjectives",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "objectives"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"objectives\")"
            },
            {
              "alias": "hasAccessToAnalytics",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "analytics"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"analytics\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "dd28407c6aee270a2c1a78dfa7c60b7b";

export default node;
